<template>
  <div class="flex-column">
    <div class="text-h6">Dienste gefiltert nach...</div>
    <div class="d-flex" style="align-items: center">
      <v-text-field v-model="textFilter" hide-details outlined dense clearable label="Filter"></v-text-field>
      <v-checkbox class="d-flex ml-8" v-model="onlyDutiesStartingWithNumber" label="nur Fahrdienste"></v-checkbox>
    </div>
    <!-- List of duties with assigned vbzNr -->

    <table  class="text-left table-style">
      <tr>
        <th style="width: 90px">Datum</th>
        <th style="width: 90px">Dienst</th>
        <th>MitarbeiterIn</th>
      </tr>
    </table>
    <div style="flex: 1; overflow-y: scroll; scrollbar-width: thin">
      <div class="text-subtitle2" v-if="sortedDuties.length === 0">Keine Dienste gefunden</div>
      <table v-if="sortedDuties.length > 0" class="mt-4 text-left table-style">
        <tr
          v-for="d in sortedDuties"
          :key="d.id"
          @click="onUserDutySelected(d)"
          v-ripple
          class="table-row-container"
          :class="selectedDuty && d.id === selectedDuty.id ? 'selected-duty' : ''"
        >
          <td style="width: 90px">{{ formatDay(d.day) }}</td>
          <td style="width: 90px">{{ d.dutyname }}</td>
          <td>{{ d.assignee }}</td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import dateTimeMixin from '@/mixins/dateTimeMixin';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import { mapState } from 'vuex';

export default {
  name: 'DutyUserSelection',
  mixins: [dateTimeMixin, wsMixin],
  props: {
    duties: Array,
    filter: String,
  },
  data() {
    return {
      selectedDuty: null,
      textFilter: this.filter,
      onlyDutiesStartingWithNumber: true,
    };
  },
  computed: {
    ...mapState('vbzWorksheet', ['userByEmployeeNr']),
    preparedDuties() {
      return this.duties.map((d) => {
        return { ...d, assignee: this.formatUser(d.employeenr) };
      });
    },
    filteredDuties() {
      return this.preparedDuties
        .filter((d) => {
          if (this.onlyDutiesStartingWithNumber) {
            return !isNaN(d.dutyname.charAt(0));
          }
          return true;
        })
        .filter((d) => {
          if (!this.textFilter) return true;
          return `${d.dutyname} ${d.assignee}`.includes(this.textFilter);
        });
    },
    sortedDuties() {
      return this.filteredDuties.slice().sort((a, b) => {
        return a.dutyname < b.dutyname ? -1 : 1;
      });
    },
  },
  methods: {
    onUserDutySelected(item) {
      this.selectedDuty = item;
      this.$emit('onUserDutySelected', item);
    },
    formatDay(dateISOString) {
      return this.formatIsoDateStringAsLocaleShortDate(dateISOString);
    },
    formatUser(employeenr) {
      if (!employeenr) return 'nicht zugewiesen';
      let user = this.userByEmployeeNr[employeenr];
      if (user) return this.mx_formatUser(user);
      return employeenr?`zugewiesen an unbekannte VBZ Nr. ${employeenr}`:'nicht zugewiesen';
    },
  },
};
</script>
<style scoped>
.selected-duty {
  font-weight: bolder;
}
</style>
